<template>
    <div class="com-mid-content text-white">
        <div class="flex align-center justify-between ptMidBox">
            <div class="ptMidLeft">
                <div style="padding-left: 40px;">
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color1">{{item.dayWeight?item.dayWeight:'0'}}</div>
                        <div class="title">今日收货量(kg)</div>
                    </div>
                </div>

                <div class="ptMidDataItem flex align-center justify-between">
                    <div class="num color2">{{item.monthWeight?item.monthWeight:'0'}}</div>
                    <div class="title">本月收货量(kg)</div>
                </div>
                <div class="ptMidDataItem flex align-center justify-between">
                    <div class="num color3">{{item.dayMoney?item.dayMoney:'0'}}</div>
                    <div class="title">今日付款金额(万元)</div>
                </div>
                <div style="padding-left: 40px;">
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color4">{{item.monthMoney?item.monthMoney:'0'}}</div>
                        <div class="title">本月付款金额(万元)</div>
                    </div>
                </div>

            </div>
            <div class="ptMidCircle">
                <div class="bgOne "></div>
                <div class="bgTwo"></div>
                <div class="info">
                    <div class="num">{{item.allWeight?item.allWeight:'0'}}</div>
                    <div class="title">总收货量(kg)</div>
                </div>
            </div>
            <div class="ptMidRight">
                <div>
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color5">{{item.allMoney?item.allMoney:'0'}}</div>
                        <div class="title">总付款金额(万元)</div>
                    </div>
                </div>
                <div style="padding-left: 40px;">
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color6">{{item.outMonthWeight?item.outMonthWeight:'0'}}</div>
                        <div class="title">本月出库量(kg)</div>
                    </div>
                </div>
                <div style="padding-left: 40px;">
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color7">{{item.outAllWeight?item.outAllWeight:'0'}}</div>
                        <div class="title">累计出库量(kg) </div>
                    </div>
                </div>


                <div>
                    <div class="ptMidDataItem flex align-center justify-between">
                        <div class="num color8">{{item.stockWeight?item.stockWeight:'0'}}</div>
                        <div class="title">库存量(kg)</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    // import {
    //     fjCentreData
    // } from "@/api/api"
	
    export default {
        name: "cityGreenLand",
        // mixins: [echartMixins],
        data() {
            return {
                item: {},
                circleImage: require("../../../assets/images/xsd/circle.png"),
                // circleImage: '',
                colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],

                //编辑
                loading: true,
                data1: [],
                mapDataList: [],
                showDianList: [],
                fjzxCenter: [],
                hszxList: [],
                timerMid: null,
                siteId:null
            }
        },
        mounted() {
         this.siteId=this.$route.query.siteId 
        },
        beforeDestroy() {
            clearTimeout(this.timerMid);
        },
        methods: {
            getData(data) {
                 this.item=data
                 this.$forceUpdate()
            },
        }
    }
</script>

<style lang="scss">
    .com-mid-content {
        min-height:200px;
        padding: 40px 5px 15px 5px;
        box-sizing: border-box;

        & .midItemBox {
            width: 15vw;
            box-sizing: border-box;
            height: 110px;
            line-height: 0.6;

            & .zdInfo {
                font-size: 36px;
                padding-top: 20px;

                & .num {
                    font-size: 36px;
                    font-weight: bold;
                }

                & .item {
                    align-items: flex-end;
                }
            }
        }

        .midItemBox.jb1 {
            padding: 27px 0 0 30px;
            background: -webkit-linear-gradient(left, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
        }

        .midItemBox.jb2 {
            padding: 27px 30px 0 0;
            background: -webkit-linear-gradient(left, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
        }

        .midCircle {
            width: 130px;
            height: 130px;
            border-radius: 50%;
            position: relative;
            box-shadow: 0 0 40px rgba(21, 88, 152, 0.2);
            background: -webkit-linear-gradient(top, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));

            .midInfo {
                width: 130px;
                height: 130px;
                position: absolute;
                top: 0;
                left: 0;
                padding-top: 38px;
                box-sizing: border-box;
                line-height: 1.1;
            }
        }

        .roteCircle {
            animation: rotateCircle 9s infinite linear;
            -webkit-animation: rotateCircle 9s infinite linear;
            /* Safari 与 Chrome */
        }


    }

    //调整******
    .leftNumItem2 {
        padding-top: 30px;
        width: 23%;
        height: 125px;
        background: url("../../../assets/img/dataK.png") center no-repeat;
        background-size: 100% 100%;
        line-height: 1.5;
        box-sizing: border-box;

        .text-color-red {
            color: #ff94a3;
        }

    }

    .ptMidBox {
        .ptMidDataItem {
            margin-bottom: 18px;
            box-sizing: border-box;

            .num {
                font-weight: bold;
                font-size: 20px;

                &.color1 {
                    color: #ff8a00;
                }

                &.color2 {
                    color: #00d8ff;
                }

                &.color3 {
                    color: #e4ff15;
                }

                &.color4 {
                    color: #ff94a3;
                }

                &.color5 {
                    color: #fdc671;
                }

                &.color6 {
                    color: #c62bff;
                }

                &.color7 {
                    color: #66ff81;
                }

                &.color8 {
                    color: #fdc671;
                }

            }

            .title {
                font-size: 14px;
            }
        }

        .ptMidLeft {
            .ptMidDataItem {
                width: 264px;
                height: 61px;
                background: url("../../../assets/img/fjmidzs.png") center no-repeat;
                background-size: 100% 100%;
                padding: 0 15px 5px 45px;
            }
        }

        .ptMidRight {
            .ptMidDataItem {
                width: 264px;
                height: 61px;
                background: url("../../../assets/img/fjmidzs2.png") center no-repeat;
                background-size: 100% 100%;
                padding: 0 45px 5px 15px;
            }
        }

        .ptMidCircle {
            width: 330px;
            height: 330px;
            background: url("../../../assets/img/fjmidCircle1.png") center no-repeat;
            background-size: 100% 100%;
            position: relative;

            .bgOne {
                width: 330px;
                height: 330px;
                background: url("../../../assets/img/fjmidCircle2.png") center no-repeat;
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 0;
                animation: rotateCircle 10s infinite linear;
                -webkit-animation: rotateCircle 10s infinite linear;
                /* Safari and Chrome */
            }

            .bgTwo {
                width: 330px;
                height: 330px;
                background: url("../../../assets/img/fjmidCircle3.png") center no-repeat;
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 0;
                animation: rotateCircle 10s infinite linear reverse;
                -webkit-animation: rotateCircle 10s infinite linear reverse;
                /* Safari and Chrome */
            }

            .info {
                width: 330px;
                height: 330px;
                position: absolute;
                left: 0;
                top: 0;
                text-align: center;
                padding: 140px 0 0 0;

                .num {
                    font-size: 32px;
                    font-weight: bold;
                    color: #fff004;
                }

                .title {
                    font-size: 22px;
                    font-weight: bold;
                    margin-top: 28px;
                }
            }
        }
    }
</style>